import React, { useState, useEffect } from 'react';
import Modal from "components/Modal";
import PubSub from 'services/PubSub/';
import { actionsType } from 'config/constants';
import ForgetPassword from './ForgetPassword';

let actions = [];

const ModalForgetPassword = () => {

    const [payload, setPayload] = useState(null);

    useEffect(() => {
        actions.push(PubSub.register(actionsType.MODAL.PASSWORD_OPEN, _open));

        return function cleanup() {
            actions.map(token => PubSub.unregister(token));
            actions = [];
        }
    }, []);

    const _open = (data) => {
        setPayload(data);
    }
    
    return (
        <Modal  customClass='modal-forgot-password' actionOpen={actionsType.MODAL.PASSWORD_OPEN} actionClose={actionsType.MODAL.PASSWORD_CLOSE} >
            <ForgetPassword  payload={payload}/>
        </Modal>
    )
}

export default ModalForgetPassword;
